
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
  for (var i = 0, iLen = list.length; i < iLen; i++) {
    var item = list[i];

    ; __append("\n  ")
    ;  if (item.__type == 'danma') { 
    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"danma\" data-name=\"")
    ; __append(escape(item.nickname))
    ; __append("\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <em class=\"c-chart__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>")
    ; __append(escape(item.content))
    ; __append("\n      </div>\n    </section>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (item.__type == 'praise') { 
    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"praise\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        ")
    ;  if (item.praise_type == '2') { 
    ; __append("\n          <em class=\"c-chart__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>给主播点了赞\n        ")
    ;  } 
    ; __append("\n        ")
    ;  if (item.praise_type == '3') { 
    ; __append("\n          <em class=\"c-chart__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>点燃一根蜡烛\n        ")
    ;  } 
    ; __append("\n        ")
    ;  if (item.praise_type == 'rat') { 
    ; __append("\n          <em class=\"c-chart__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>献上新春祝福\n        ")
    ;  } 
    ; __append("\n      </div>\n    </section>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (list[i].__type == 'gift') { 
    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"gift\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.user.avatar)))
    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <em class=\"c-chart__host\">")
    ; __append(escape(item.user.nickname))
    ; __append("：</em>赠送了<span class=\"c-chart__giftname\">")
    ; __append(escape(item.gift.desc))
    ; __append("</span><span class=\"c-chart__giftpic\" style=\"background-image: url(")
    ; __append(escape(item.gift.src))
    ; __append(")\"></span>\n      </div>\n    </section>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (item.__type == 'online') { 
    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"online\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <span class=\"c-chart__online\">欢迎 ")
    ; __append(escape(item.nickname))
    ; __append(" 进入直播间</span>\n      </div>\n    </section>\n  ")
    ;  } 
    ; __append("\n  ")
    ;  if (item.__type == 'system') { 
    ; __append("\n    <section class=\"c-chart__item\" data-type=\"system\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <span class=\"c-chart__system\">")
    ; __append(escape(item.content))
    ; __append("</span>\n      </div>\n    </section>\n  ")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/chartList/item.ejs
// module id = 588
// module chunks = 0